import React, { useReducer, useState } from "react";
import "./frais.scss";
import Delete from "../../../component/dialog/delete/Delete.tsx";
// import SearchBar from "../../../component/searchBar/Search.tsx";
import { Tooltip } from "@mui/material";
import { Add, CancelRounded, CheckCircle, Print } from "@mui/icons-material";
import NewFrais from "./NewFrais.tsx";
import UpdateFrais from "./UpdateFrais.tsx";
import {
  classeType,
  montantType,
  requestType,
  schooYearType,
} from "../../../types/GlobalType.ts";
import { accountService } from "../../../_services/accountServices.js";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller.js";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import MyLoading from "../../../component/loader/MyLoading.tsx";
import toast from "react-hot-toast";
import { orderBy } from "lodash";
import { useNavigate } from "react-router-dom";
import ConnexionErrorDiv from "../../../component/nodata/ConnexionErrorDiv.js";

const FraisScolaire = () => {
  const [openArchiveFrais, setopenArchiveFrais] =
    React.useState<Boolean>(false);
  const [openActivateFrais, setopenActivateFrais] =
    React.useState<Boolean>(false);
  const [loadingDeleteBtn, setLoadingDeleteBtn] =
    React.useState<boolean>(false);
  const [openAddFrais, setopenAddFrais] = React.useState<boolean>(false);
  const [openUpdateFrais, setopenUpdateFrais] = React.useState<boolean>(false);

  const [dataClasses, setDataClasses] = useState<classeType[]>([]);
  const [dataSY, setDataSY] = useState<schooYearType[]>([]);
  const [selectedClasseId, setselectedClasseId] = useState<number | string>();
  const [selectedAnneeId, setselectedAnneeId] = useState<number | string>();
  const [selectedAnneeValue, setselectedAnneeValue] = useState<string>("");

  const [dataMontantAnnuel, setDataMontantAnnuel] = useState<montantType[]>([]);
  const [singleMontantAnnuelData, setsingleMontantAnnuelData] =
    useState<montantType>();

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const navigate = useNavigate();

  const [itemId, setItemId] = useState<string | number>();
  const [stateReload, dispatchReload] = useReducer((x) => x + 1, 0);

  const fetchAllSY = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    API_CONFIG.ANNEE_SCOLAIRE.getAll(token)
      .then((response) => {
        setState({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        setDataSY(response.data.data);
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setState({
            isLoading: false,
            successMessage: false,
            errorMessage: "ERR_NETWORK",
          });
        }

        catchErrorApiCall(err);
      });
  };
  const fetchAllClasses = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.CLASSE.getAll(token);
      setDataClasses(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const fetchAllMontant = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.MONTANT_ANNUEL.getAll(token);
      setDataMontantAnnuel(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const handleActivateFrais = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.MONTANT_ANNUEL.active(id, token);
      setLoadingDeleteBtn(false);
      setopenActivateFrais(false);
      dispatchReload();
      toast.success("Frais scolaire activé avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleArchiveFrais = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let response = await API_CONFIG.MONTANT_ANNUEL.desactive(id, token);
      console.log(response);
      setLoadingDeleteBtn(false);
      setopenArchiveFrais(false);
      dispatchReload();
      toast.success("Frais scolaire archivé avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  let sortedData: montantType[] = [];

  if (dataMontantAnnuel.length > 0) {
    sortedData = orderBy(
      dataMontantAnnuel,
      ["classe_designation", "montant_status"],
      ["asc", "desc"]
    );
  }

  React.useEffect(() => {
    fetchAllSY();
    fetchAllClasses();
    fetchAllMontant();
  }, [stateReload]);

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <div className="topFrais">
          {state.isLoading && <MyLoading isLoading={state.isLoading} />}
          <div className="card_Classe">
            <div className="headerFrais">
              <h2 className="card-title">
                Frais scolaire{" "}
                {selectedAnneeValue && `Année: ${selectedAnneeValue}`}
              </h2>

              <div className="input-container">
                <div style={{ marginLeft: "10px", width: "100%" }}>
                  <select
                    value={selectedAnneeValue}
                    onChange={(e) => setselectedAnneeValue(e.target.value)}
                    className="selectClasse"
                  >
                    <option value={""}>{"TOUTES"}</option>
                    {dataSY.map((value, index) => {
                      return (
                        <option
                          key={index}
                          value={value.annee_scolaire_designation}
                        >
                          {value.annee_scolaire_designation.toUpperCase()}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {/* <SearchBar /> */}
                <button className="add_button_pers">
                  <Tooltip title="Imprimer">
                    <Print className="ico" />
                  </Tooltip>
                </button>
                <button className="add_button_pers">
                  <Tooltip title="Ajouter">
                    <Add
                      className="ico"
                      onClick={() => setopenAddFrais(true)}
                    />
                  </Tooltip>
                </button>
              </div>
            </div>
            <div className="table_component" role="region">
              <table>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Classe</th>
                    <th>Montant</th>
                    <th>Année scolaire</th>
                    <th>Status</th>
                    <th className="actionHeader">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData
                    .filter((value) =>
                      value.annee_scolaire_designation
                        ?.toLowerCase()
                        .includes(selectedAnneeValue.toLowerCase())
                    )
                    .map((item, index) => {
                      let anneeId: number | undefined;
                      let classId: number | undefined;

                      for (let val of dataSY) {
                        if (val.annee_scolaire_id === item.annee_scolaire_id) {
                          anneeId = val.annee_scolaire_id;
                        }
                      }
                      for (let val of dataClasses) {
                        if (val.classe_id === item.classe_id) {
                          classId = val.classe_id;
                        }
                      }

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.classe_designation}</td>
                          <td>
                            {item.montant}
                            {" $ "}
                          </td>
                          <td>{item.annee_scolaire_designation}</td>
                          <td>
                            {" "}
                            {item.montant_status ? (
                              <Tooltip title="Activé" placement="left">
                                <CheckCircle
                                  style={{ color: "#28a745", fontSize: "14px" }}
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip title="Archivé" placement="left">
                                <CancelRounded
                                  style={{ color: "#7f1d18", fontSize: "14px" }}
                                />
                              </Tooltip>
                            )}
                          </td>
                          <td className="actionSection">
                            <span
                              className="edit"
                              onClick={() => {
                                setselectedAnneeId(anneeId);
                                setselectedClasseId(classId);
                                setsingleMontantAnnuelData(item);
                                setopenUpdateFrais(true);
                              }}
                            >
                              Edit
                            </span>
                            {item.montant_status ? (
                              <span
                                className="archive"
                                onClick={() => {
                                  setItemId(item.montant_id);
                                  setopenArchiveFrais(true);
                                }}
                              >
                                Archiver
                              </span>
                            ) : (
                              <span
                                className="archive"
                                onClick={() => {
                                  setItemId(item.montant_id);
                                  setopenActivateFrais(true);
                                }}
                              >
                                Activer
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {openAddFrais && (
        <NewFrais
          setOpen={setopenAddFrais}
          dataClasse={dataClasses}
          dataYear={dataSY}
          dispatchReload={dispatchReload}
        />
      )}
      {openUpdateFrais && (
        <UpdateFrais
          setOpen={setopenUpdateFrais}
          data={singleMontantAnnuelData}
          dispatchReload={dispatchReload}
          dataClasse={dataClasses}
          dataYear={dataSY}
          selectedClasseId={selectedClasseId}
          selectedAnneeId={selectedAnneeId}
        />
      )}

      {openActivateFrais && (
        <Delete
          setOpen={setopenActivateFrais}
          itemId={itemId}
          label={"Voulez-vous vraiment activer ce montant?"}
          handleDelete={handleActivateFrais}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
      {openArchiveFrais && (
        <Delete
          setOpen={setopenArchiveFrais}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver ce montant?"}
          handleDelete={handleArchiveFrais}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Archivage"
        />
      )}
    </>
  );
};

export default FraisScolaire;
